export const environment = {
    production: true,
    ApiUrl :"https://sams-api-prod.azure.chevron.com/api/v1/",
    calConfig: {
      "autoSignIn": true,
      "popupForLogin": false,
      "cacheLocation": "localStorage",
      "instance": "https://login.microsoftonline.com/",
      "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
      "clientId":"1f1e090a-5bb3-450e-b840-dd096e99bd91",
      "redirectUri": "https://sams-prod.azure.chevron.com",
      "oidcScopes": ["openid", "profile", "User.Read","offline_access"],
      "graphScopes": ["User.Read", "User.Read.All"],
      "scopes": ['https://sams-prod.azure.chevron.com/user_impersonation'],
      "name": 'Prod'
    }
  };